import { useUserPhotoQuery } from "@/common/api/user/use-user-photo.query";
import { getInitials } from "@/common/helpers/get-initials";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Loader, LoaderSize, LoaderVariant } from "@/components/ui/loader";
import { AvatarLightboxDialog } from "@/components/user-avatar/avatar-lightbox-dialog";
import { useTranslation } from "react-i18next";

export enum AvatarClickAction {
  None = "None",
  Zoom = "Zoom",
}

export interface UserAvatarProps {
  userAzureObjectUuid?: string | null;
  name?: string;
  clickAction?: AvatarClickAction;
  className?: string;
}
export const UserAvatar = ({
  userAzureObjectUuid,
  name,
  clickAction = AvatarClickAction.None,
  className,
}: UserAvatarProps) => {
  const { t } = useTranslation("common");
  const { data, isLoading } = useUserPhotoQuery({ userAzureObjectUuid });

  const altText = name ? t("ImageOf", { name }) : t("UserImage");

  const avatar = (
    <Avatar className={className}>
      {data ? (
        <AvatarImage src={data} alt={altText} />
      ) : isLoading ? (
        <AvatarFallback>
          <Loader size={LoaderSize.Small} variant={LoaderVariant.Wheel} />
        </AvatarFallback>
      ) : (
        <AvatarFallback>{name ? getInitials(name) : "?"}</AvatarFallback>
      )}
    </Avatar>
  );

  if (clickAction === AvatarClickAction.Zoom && userAzureObjectUuid) {
    return <AvatarLightboxDialog userAzureObjectUuid={userAzureObjectUuid} alt={altText} trigger={avatar} />;
  }

  return avatar;
};
